import Fetch, { fetchConfig } from '@/hooks/fetch';
import { states } from '@/constants/lifecycle';
import actions from '../constants';

export default {
  useFetchSubscriptions: (readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_SUBSCRIPTIONS,
    states.NONE,
    {},
    fetchConfig([], () => readStatus !== states.SUCCESS),
  ),
};
